import { Result } from 'domain/types';
import UpdateWidgetClient from 'use-case/widget/update/updateWidgetClient';
import UpdateWidgetCriteria from 'use-case/widget/update/updateWidgetCriteria';
import BasicEntity from 'domain/entity/basicEntity';

export type UpdateWidgetResult = Result<BasicEntity>;
export type UpdateWidget = (criteria: UpdateWidgetCriteria) => Promise<UpdateWidgetResult>;

export default (updateWidgetClient: UpdateWidgetClient): UpdateWidget => (criteria: UpdateWidgetCriteria): Promise<UpdateWidgetResult> =>
    updateWidgetClient(criteria);
